import { render, staticRenderFns } from "./ModalPrivacyPolicy.vue?vue&type=template&id=5217161e"
import script from "./ModalPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./ModalPrivacyPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports